import { get } from 'lodash';
import { fetch } from '@utils/utils';
import * as T from '@modules/hr-workTimes/claim/_claimsTypes';

export const getClaim = ({ addError, addSuccess }) => async (id: string): Promise<T.Claim> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/worktime/claims/${id}`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' })
    });

    const json: T.Claim = await response.json();
    addSuccess();
    return json;
  } catch (err) {
    addError(err.message);
    return {};
  }
};

export const putClaim = ({ addError, addSuccess }) => async (body): Promise<T.Claim | null> => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/worktime/claims/${body.id}`, {
      method: 'PUT',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(body)
    });

    addSuccess();
    const json = await response.json();
    return json;
  } catch (err) {
    addError(err.message);
    return null;
  }
};

export const getSummary = async ({ employee, from, to }: any) => {
  try {
    const response: any = await fetch(`/metropolis/api/hr/workplan/worktime/claims/${get(employee, 'id')}/summary`, {
      method: 'GET',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      params: { from, to }
    });

    const json = await response.json();

    return json;
  } catch (err) {
    return {};
  }
};



// WEBPACK FOOTER //
// ./src/modules/hr-workTimes/_workTimesActions.ts